// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"98076dc3","195":"76e7ca00","391":"e2c4460a","950":"1f14ef47"}[chunkId] + ".chunk.js";
};